import type { AtTag } from "shared/util/tag";
import { type AbsolutePath, getURL } from "shelving";
import { BLOCK_USER, FOLLOW_USER, UNBLOCK_USER, UNFOLLOW_USER } from "shared/api";
import { Button, CopyButton, Icon, PathButton } from "shared/react";
import { getProfilePath, getProfileTag } from "shared/schema";
import { CreatorMenu } from "../create/CreatorMenu.js";
import { getCallAPIWithNotice } from "../util/api.js";
import { useFollowedData, useFollowerData } from "../util/data.js";
import { useItem } from "../util/db.js";

export function ProfileMenu({ uid }: { uid: string }): React.ReactElement {
	const profile = useItem("profile", uid).data;
	const { verified } = profile;
	const { status: yourFollowingStatus } = useFollowedData(uid);
	const { status: theirFollowingStatus } = useFollowerData(uid);
	const path: AbsolutePath = getProfilePath(profile);
	const tag: AtTag = getProfileTag(profile);
	return (
		<>
			<nav className="flex-column gap-hairline">
				<h2 className="label">Profile</h2>
				<div className="grid gap-hairline">
					<PathButton path={path}>
						<Icon icon="post" /> <span>Posts</span>
					</PathButton>
					<PathButton path={`${path}/earned`}>
						<Icon icon="badge" /> <span>Earned badges</span>
					</PathButton>
				</div>
			</nav>
			<CreatorMenu path={path} verified={verified} />
			{yourFollowingStatus === "you" || theirFollowingStatus === "you" ? null : (
				<nav className="flex-column gap-hairline">
					{yourFollowingStatus === "approved" || yourFollowingStatus === "requested" ? (
						<Button onClick={getCallAPIWithNotice(UNFOLLOW_USER, uid)}>Unfollow profile</Button>
					) : (
						<Button onClick={getCallAPIWithNotice(FOLLOW_USER, uid)}>Follow profile</Button>
					)}
					{theirFollowingStatus === "blocked" ? (
						<Button onClick={getCallAPIWithNotice(UNBLOCK_USER, uid)}>Unblock profile</Button>
					) : (
						<Button onClick={getCallAPIWithNotice(BLOCK_USER, uid)}>Block profile</Button> //
					)}
				</nav>
			)}
			<nav className="flex-row flex-stretch gap-hairline">
				<CopyButton copy={tag}>Copy tag</CopyButton>
				<CopyButton copy={getURL(path).href}>Copy link</CopyButton>
			</nav>
		</>
	);
}
